import { render, staticRenderFns } from "./madeInMapping.vue?vue&type=template&id=4d857fab&scoped=true"
import script from "./madeInMapping.vue?vue&type=script&lang=js"
export * from "./madeInMapping.vue?vue&type=script&lang=js"
import style0 from "./madeInMapping.vue?vue&type=style&index=0&id=4d857fab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d857fab",
  null
  
)

export default component.exports